<script>
import TopNavbar from "@/layout/dashboard/TopNavbar.vue";
import {axiosApiInstance} from "@/axiosInterceptor";

export default {
  name: 'referent-index',
  components: {
    TopNavbar
  },
  data() {
    return {
      referents: [],
      referentToDelete: null,
      flash: null,
    }
  },
  mounted() {
    this.getReferents()
  },
  methods: {
    clearFlash() {
      this.flash = null
    },
    updateFlash(message, type) {
      this.flash = {message: message, type: type}
      setTimeout(() => {
        this.clearFlash()
      }, 3000)
    },
    getReferents() {
      axiosApiInstance.get(process.env.VUE_APP_API_URL + '/referent/list')
          .then(response => {
            this.referents = response.data.referents
          })
          .catch(e => {
            this.updateFlash(e.message, 'danger')
          })
    },
    searchInReferents() {
      let field = document.getElementById('searchField')

      if (field.value !== '' && field.value !== null) {
        axiosApiInstance.post(process.env.VUE_APP_API_URL + '/referent/research', {keyword: field.value}).then(response => {
          if (response.data) {
            this.referents = response.data.referents
          }
        }).catch(() => {
          this.updateFlash("Une erreur est survenue.", 'danger')
        })
      } else {
        this.getReferents()
      }
    },
    newReferent() {
      this.$router.push('/referent/new')
    },
    openDeleteModalReferent(toDeleteReferentId) {
      const modal = document.querySelector('.modal')

      this.referentToDelete = toDeleteReferentId

      modal.style.display = 'block'
    },
    hiddeDeleteModalReferent() {
      const modal = document.querySelector('.modal')

      this.referentToDelete = null

      modal.style.display = 'none'
    },
    deletedReferent() {
      if (this.referentToDelete) {
        axiosApiInstance.get(process.env.VUE_APP_API_URL + '/referent/delete/' + this.referentToDelete).then(response => {
          if (response.data) {
            this.getReferents()
            this.hiddeDeleteModalReferent()
          }
        }).catch(() => {
          this.updateFlash("Une erreur est survenue.", 'danger')
        })
      }
    },
    editReferent(toEditReferentId) {
      this.$router.push('/referent/' + toEditReferentId)
    },
    viewCandidateList(toViewReferentId) {
      this.$router.push('/referent/users/' + toViewReferentId)
    },
  }
}

</script>

<template>
  <div class="wrapper">
    <div class="position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 11;padding-top:33px !important;">
      <div :class="'toast bg-' + flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer" @click="clearFlash"></button>
        </div>
      </div>
    </div>

    <side-bar>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div class="content">
        <h1>Liste de mes référents</h1>
        <div class="d-flex mb-3">
          <input class="form-control mr-sm-2 w-50" type="search" id="searchField" placeholder="Recherche"
                 aria-label="Search">
          <button class="btn btn-secondary my-2 my-sm-0" type="submit" @click="searchInReferents()">Recherche</button>
        </div>
        <button class="btn btn-primary my-2 my-sm-0" @click="newReferent()">Nouveau Référent</button>
        <table class="table text-left">
          <thead>
          <tr>
            <th class="text-left">Nom</th>
            <th class="text-left">Prénom</th>
            <th class="text-left">Email</th>
            <th class="text-center">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="referents && referents.length > 0" v-for="referent in referents">
            <td class="text-left">{{ referent.lastName }}</td>
            <td class="text-left">{{ referent.firstName }}</td>
            <td class="text-left">{{ referent.email }}</td>
            <td class="w-50">
              <div class="d-flex justify-content-around">
                <button class="btn btn-primary"
                        @click="openDeleteModalReferent(referent.id)">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
                <button class="btn btn-primary"
                        @click="editReferent(referent.id)">
                  <i class="fa-solid fa-pen"></i>
                </button>
                <button class="btn btn-primary"
                        @click="viewCandidateList(referent.id)">
                  <i class="fa-solid fa-users"></i> Candidats suivis
                </button>
              </div>
            </td>
          </tr>
          <tr v-else>
            <td colspan="4">
              Aucun réferent trouvé
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="text-right mr-3 mt3">
              <i class="fa-solid fa-xmark" @click="hiddeDeleteModalReferent"></i>
            </div>
            <div class="modal-body">
              <h3 class="ml-3 modal-title">Êtes-vous sur de vouloir supprimer ce référent?</h3><br>
              <p class="ml-3">
                La suppression sera définitive.
              </p>

              <div class="ml-3 mb-3 mt-3 d-flex justify-content-between">
                <button type="button" class="btn btn-primary" @click="deletedReferent">Confimer</button>
                <button type="button" class="btn btn-secondary" @click="hiddeDeleteModalReferent">Annuler</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>